import { LockIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

/**
 * The accent "lock" pill shown on a plan-gated control — a lock icon plus a
 * short label ("Pro", "Requires Basic", …). Shared by every gated surface so the
 * upsell affordance stays visually consistent; pass the resolved copy as `label`
 * and the gating decision stays in the caller / `useCapabilities`.
 */
export function PlanLockBadge({ label, className }: { label: string; className?: string }) {
  return (
    <span
      className={cn(
        'border-foreground/20 bg-foreground/10 text-ox-cyan inline-flex shrink-0 items-center gap-1 border px-2 py-0.5 text-[10px] font-semibold tracking-tight uppercase',
        className
      )}
    >
      <LockIcon className="size-2.5" />
      {label}
    </span>
  )
}
